export const testDriveCatalog = {
    getLimit(){
        const url = '/api/form/system/config/limits/testdrive';
        return url;
    },

    getModels(params) {
        let url = `/api/form/${params.brandId}/testdrive/catalog/models`;
        if (params.dealerId) {
            url = `${url}?dealer=${params.dealerId}`;
        }
        return url;
    },

    getDealers(params) {
        let url = `/api/form/${params.brandId}/testdrive/dealer/centers?google_city_id=${params.placeId || ''}`;
        if(params.cityId) {
            url = `${url}&city_id=${params.cityId}`;
        }
        return url;
    },

    getTimeSlots(params) {
        const url = `/api/form/${params.brandId}/testdrive/time_slots?vehicle=${params.vehicleId}`;
        return url;
    },

    sendCodeAgain(params) {
        const url = `/api/form/${params.brandId}/testdrive/send_code_again`;
        return url;
    },

    getBookingInfo(params) {
        const url = `/api/form/${params.brandId}/testdrive/complete`;
        return url;
    }
};



// WEBPACK FOOTER //
// ./src/urlConstructor/testDriveCatalog.js